//* 组件库
import type { UiTableOption2 } from "various-ui";

export interface SearchDiagramVars {
    replenish: number;
    size: number;
    data: { key: string; min: number; max: number; width: number; replenish: boolean }[];
}

export interface SearchDiagramHover {
    "spacing"?: number;
    "box-shadow"?: number;
}

export const SearchDiagramPropsOption = {
    //* 表格数据源
    data: { type: Array as PropType<any[]>, required: true },
    //* 表格激活状态配置
    hover: { type: Object as PropType<SearchDiagramHover> },
    //* 表格配置项
    option: { type: Array as PropType<UiTableOption2[]>, required: true },
    //* 表格无数据时的提示文本
    placeholder: { type: String, default: "Please input" },
    //* mode
    mode: { type: String },
} as const;

export type SearchDiagramProps = ExtractPropTypes<typeof SearchDiagramPropsOption>;
export const SearchDiagramEmits = {
    sort: (_key: string, _sort: string) => true,
    click: (_data: any) => true,
};
